import { Components, Theme } from '@mui/material'
import { DISABLED_OPACITY } from './disabledOpacity'
import { primaryContainedButtonStyle, secondaryContainedButtonStyle } from './MuiButton'

export const MuiFab: Components<Omit<Theme, 'components'>>['MuiFab'] = {
  defaultProps: {
    size: 'medium',
  },
  styleOverrides: {
    root: {
      '&.Mui-disabled': {
        opacity: DISABLED_OPACITY,
      },
    },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: ({ theme }) => primaryContainedButtonStyle(theme),
    },
    {
      props: { color: 'secondary' },
      style: ({ theme }) => secondaryContainedButtonStyle(theme),
    },
  ],
}
